import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import mergeDeep from 'src/locale/helpers/mergeTranslations';
import addNewPropertyFlowEn from 'src/locale/chunks/add_new_property_flow.json';
import buttonsEn from 'src/locale/chunks/buttons.json';
import companyDetailsEn from 'src/locale/chunks/company_details.json';
import correctionsEn from 'src/locale/chunks/corrections.json';
import dashboardPageEn from 'src/locale/chunks/dashboard_page.json';
import dashboardWizaedEn from 'src/locale/chunks/dashboard_wizard.json';
import emailEn from 'src/locale/chunks/email.json';
import enrollmentModalEn from 'src/locale/chunks/enrollment_modal.json';
import errorsEn from 'src/locale/chunks/errors.json';
import generalEn from 'src/locale/chunks/general.json';
import logInFlowEn from 'src/locale/chunks/log_in_flow.json';
import mfaEN from 'src/locale/chunks/mfa.json';
import moveOutModalEn from 'src/locale/chunks/move_out_modal.json';
import postChargesModalEn from 'src/locale/chunks/post_charge_modal.json';
import residenciesPageEn from 'src/locale/chunks/residencies_page.json';
import signUpFlowEn from 'src/locale/chunks/sign_up_flow.json';
import tenantPortalPageEn from 'src/locale/chunks/tenant_portal_page.json';
import utilitiesEn from 'src/locale/chunks/utilities.json';
import allocationsEn from 'src/locale/chunks/allocations.json';
import mobilePageEn from 'src/locale/chunks/mobile_page.json';
import unitModalEn from 'src/locale/chunks/unit_modal.json';
import profileSettingsEn from 'src/locale/chunks/profile_settings.json';
import subscriptionsEn from 'src/locale/chunks/subscriptions.json';
import residentAccountEn from 'src/locale/chunks/resident_account.json';
import feesPageEn from 'src/locale/chunks/fees_page.json';
import teamPageEn from 'src/locale/chunks/team_page.json';
import fileCabinetEn from 'src/locale/chunks/file_cabinet.json';
import adminPageEn from 'src/locale/chunks/admin_page.json';
import appMenusEn from 'src/locale/chunks/app_menus.json';
import reportingEn from 'src/locale/chunks/reporting.json';
import fsePageEn from 'src/locale/chunks/fse_page.json';
import sharedKeysEn from 'src/locale/chunks/shared_keys.json';
import reimbursementDashboardEn from 'src/locale/chunks/reimbursement_dashboard.json';
import portfoliosPropertiesPageEn from 'src/locale/chunks/portfolios_properties_page.json';
i18next.use(LanguageDetector).use(initReactI18next).init({
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: mergeDeep(addNewPropertyFlowEn, buttonsEn, companyDetailsEn, correctionsEn, dashboardPageEn, dashboardWizaedEn, enrollmentModalEn, emailEn, errorsEn, generalEn, logInFlowEn, mfaEN, moveOutModalEn, postChargesModalEn, residenciesPageEn, signUpFlowEn, tenantPortalPageEn, utilitiesEn, allocationsEn, mobilePageEn, unitModalEn, profileSettingsEn, subscriptionsEn, residentAccountEn, feesPageEn, teamPageEn, fileCabinetEn, adminPageEn, appMenusEn, reportingEn, fsePageEn, sharedKeysEn, reimbursementDashboardEn, portfoliosPropertiesPageEn)
    }
  },
  lng: 'en',
  fallbackLng: 'en'
});